import React from 'react';
import cn from 'classnames';
import { makeStyles } from '@mui/styles';
import { Typography, Button } from '@mui/material';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SendAutomarkerResponseModal from './SendAutomarkerResponseModal';
import ReturnToDraftModal from './ReturnToDraftModal';
import WarningModal from './WaringModal'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: theme.breakpoints.values.md,
  },
  overrideMargin: {
      marginBottom: theme.spacing(1),
    },
  contentBlock: {
    width: 840,
    boxSizing: 'border-box',
  },
  itemHeader: {
    marginBottom: '16px',
  },
  contentText: {
    padding: '8px 4px',
    fontSize: 18,
    lineHeight: 1.6,
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    wordBreak: 'normal',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
    marginBottom: 8,
  },
  actionButton: {
    height: 48,
    width: 262,
    borderRadius: 26,
    fontSize: 18,
    fontWeight: 500,
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 16,
    paddingRight: 16,
    textTransform: 'uppercase',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiButton-startIcon': {
      marginRight: 8,
      marginLeft: 0,
    },
    '& .MuiButton-label': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },

  sendButton: {
    backgroundColor: 'rgba(113, 61, 144, 1)',
    '&:hover': {
      backgroundColor: 'rgba(113, 61, 144, 0.92)',
    },
  },
}));

const text = `Please check with the Paper AM before sending the task to the ARC AI Automarker.The task 
should not be sent until it's completely signed off.Once it's sent,the task will be locked and 
cannot be edited further.The task must be sent to the Automarker before the Test can be set to 
Pretesting or Live.

Only use Return to draft in exceptional circumstances when asked to do so by the Paper AM.
The task must be re-sent to the Automarker before it can be included in a Pretestingor a Live Test.`;

export default function SendToAutoMarkerButtons({
  className: propsClass,
  disabled = false,
  // true => show SEND; false => show RETURN
  showSendAutoMarkerButton,
  onSendToAutomarker,
  onReturnToDraft,
  // Modals
  responseModalOpen,
  responseError,
  onCloseResponseModal,
  returnToDraftModalOpen,
  onCloseReturnToDraftModal,
  warningModalOpen,
  onCloseWarningModal,
  ...other
}) {
  const classes = useStyles();
  const sendTitle = 'SEND TO AUTOMARKER';
  const returnTitle = 'RETURN TO DRAFT';
  return (
    <div className={cn(classes.root, classes.overrideMargin, propsClass)} {...other}>
      <br />
      <Typography variant="h6" className={classes.itemHeader}>
        Send task to ARC AI Automarker
      </Typography>
      <div className={classes.contentBlock}>
        <Typography className={classes.contentText}>
          {text}
        </Typography>
        <div className={classes.buttonRow}>
          {showSendAutoMarkerButton ? (
            <Button
              variant="contained"
              startIcon={<LockOutlinedIcon />}
              onClick={onSendToAutomarker}
              disabled={disabled}
              className={cn(classes.actionButton, classes.sendButton)}
              disableElevation
              title={sendTitle}
            >
              {sendTitle}
            </Button>
          ) : (
            <Button
              variant="outlined"
              startIcon={<ModeEditOutlinedIcon />}
              onClick={onReturnToDraft}
              disabled={disabled}
              className={classes.actionButton}
              title={returnTitle}
            >
              {returnTitle}
            </Button>
          )}
        </div>
      </div>
      {responseModalOpen && (
        <SendAutomarkerResponseModal
          open={responseModalOpen}
          error={responseError}
          onClose={onCloseResponseModal}
        />
      )}
      {returnToDraftModalOpen && (
        <ReturnToDraftModal open={returnToDraftModalOpen} onClose={onCloseReturnToDraftModal} />
      )}
      {warningModalOpen && <WarningModal open={warningModalOpen} onClose={onCloseWarningModal} />}
    </div>
  );
}